import http from '@/utils/http'

export function getQuestionFeedbackCategories(){
    return  http.get('/question_feedback_categories')
}

export function getQuestionFeedbacks(params){
    return  http.post('/question_feedbacks', params)
}